import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pantry-image-room-frizzer-view-nodata"
}
const _hoisted_2 = {
  key: 1,
  class: "pantry-image-room-frizzer-view"
}
const _hoisted_3 = { class: "pantry-image-room-frizzer-view-image-list-view" }
const _hoisted_4 = { class: "pantry-image-room-frizzer-view-horizontal-image" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pantry-image-room-frizzer-view-dummy" }, null, -1)
const _hoisted_6 = {
  key: 2,
  class: "pantry-image-room-frizzer-view-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryImageRoomItem = _resolveComponent("PantryImageRoomItem")
  const _component_PantryImageEmptyView = _resolveComponent("PantryImageEmptyView")

  return (_ctx.isNoData())
    ? (_openBlock(), _createBlock("div", _hoisted_1))
    : (!_ctx.isEmpty())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _withDirectives(_createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getHorizontalImages(), (item) => {
                return (_openBlock(), _createBlock(_component_PantryImageRoomItem, {
                  key: item.id,
                  roomId: _ctx.roomId,
                  data: item,
                  imageUpdate: _ctx.updateDisplayKey,
                  doorTypeId: _ctx.doorTypeId,
                  isSelect: _ctx.isSelect,
                  onSelectImage: _ctx.onSelectImage,
                  onShowDate: _ctx.onShowDate
                }, null, 8, ["roomId", "data", "imageUpdate", "doorTypeId", "isSelect", "onSelectImage", "onShowDate"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512), [
              [_vShow, _ctx.isShowHorizontal()]
            ]),
            _createVNode("div", {
              class: "pantry-image-room-frizzer-view-image",
              style: _ctx.styleRoomImageView
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getImages(), (item) => {
                return (_openBlock(), _createBlock(_component_PantryImageRoomItem, {
                  key: item.id,
                  roomId: _ctx.roomId,
                  data: item,
                  imageUpdate: _ctx.updateDisplayKey,
                  size: _ctx.getSize(),
                  isSelect: _ctx.isSelect,
                  onSelectImage: _ctx.onSelectImage,
                  onShowDate: _ctx.onShowDate
                }, null, 8, ["roomId", "data", "imageUpdate", "size", "isSelect", "onSelectImage", "onShowDate"]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 4),
            _hoisted_5
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_PantryImageEmptyView)
        ]))
}